export function getUtmParamsFromUrl(url: string) {
    const params = new URL(url, window.location.origin).searchParams;
    return {
        optimizely_campaign: params.get("utm_campaign") || "",
        optimizely_medium: params.get("utm_medium") || "",
        optimizely_source: params.get("utm_source") || "",
    };
}

export function getUtmParamsFromSessionStorage() {
    return {
        optimizely_campaign: sessionStorage.getItem("utm_campaign") || undefined,
        optimizely_medium: sessionStorage.getItem("utm_medium") || undefined,
        optimizely_source: sessionStorage.getItem("utm_source") || undefined,
    };
}